import axios from 'axios';

export const getSuggestedMentoringList = (order, skip, limit) => axios.get('/v1/public/togethers/suggested', { params: { order, skip, limit } });
export const getScheduledMentoringList = (order, skip, limit) => axios.get('/v1/public/togethers/accepted', { params: { order, skip, limit } });

export const getSuggestedKnowledgeTalkDetail = (mentoringId) => axios.get(`/v1/public/togethers/suggested/${mentoringId}`);
export const getAcceptedKnowledgeTalkDetail = (mentoringId) => axios.get(`/v1/public/togethers/accepted/${mentoringId}`);

/**
 * 멘토링 제안하기.
 * @param title: string             제안하는 멘토링 제목
 * @param content: string           제안하는 멘토링 내용
 * @param relatedCollection: string 연결된 컬렉션 ID
 */
export const suggestMentoring = (title, content, relatedCollection) => axios.post('/v1/private/togethers', { title, content, relatedCollection });

/**
 * 제안된 지식톡 수락하기 / 지식톡 생성하기
 * @param id: string          제안된 지식톡 ID (제안된 지식톡 없이 생성하는 경우 보내지 않는다)
 * @param title: string       수락하는 지식톡 제목
 * @param content: string     수락하는 지식톡 내용
 * @param zoomLink: string    zoom ID
 */
export const acceptMentoring = (mentoringInfo) => axios.post('/v1/private/togethers/accept', mentoringInfo, { headers: { 'Content-Type': 'multipart/form-data' } });

export const UpdateMentoring = (mentoringInfo, talkId) => axios.put(`/v1/private/togethers/accept/${talkId}`, mentoringInfo, { headers: { 'Content-Type': 'multipart/form-data' } });

export const toggleLikeMentoring = (mentoringId) => axios.post(`/v1/private/togethers/${mentoringId}/like`);

export const sendChat = (mentoringId, content) => axios.post(`/v1/private/togethers/${mentoringId}/chat`, { content });

export const getChatList = (mentoringId) => axios.get(`/v1/public/togethers/${mentoringId}/messages`);

// 이벤트 생성
export const createTogetherEvent = (togetherId, title, content, startAt, endAt, entryFee, maxParticipants, currency, sponsorable, alwaysOpen, freeEntry) => axios.post(`/v1/private/togethers/${togetherId}/events`, { title, content, startAt, endAt, entryFee, maxParticipants, currency, sponsorable, alwaysOpen, freeEntry });

// 이벤트 수정
export const updateTogetherEvent = (eventId, title, content, startAt, endAt, currency, sponsorable, alwaysOpen, freeEntry) => axios.put(`/v1/private/events/${eventId}`, { title, content, startAt, endAt, currency, sponsorable, alwaysOpen, freeEntry });

// 이벤트 상세조회
export const getEventInfo = (eventId) => axios.get(`/v1/public/events/${eventId}`);

// 투게더에 등록된 이벤트 조회
export const getTogetherEvents = (togetherId) => axios.get(`/v1/public/togethers/${togetherId}/events`);

// 투게더 삭제
export const deleteTogetherEvent = (eventId) => axios.delete(`/v1/private/events/${eventId}`);

// 특정 사용자가 만든 투게더 목록조회
export const getUserTogethers = (userId) => axios.get(`/v1/public/users/${userId}/togethers`);

// 내가 만든 이벤트 목록 조회
export const getMyEvents = () => axios.get('/v1/private/users/my/events');

// 이벤트에 관련된 미니북 추가
export const addMiniBookToEvent = (eventId, collectionId) => axios.post(`/v1/private/events/${eventId}/associated-collections/${collectionId}`);

// 이벤트에 관련된 미니북 삭제
export const deleteMiniBookFromEvent = (eventId, collectionId) => axios.delete(`/v1/private/events/${eventId}/associated-collections/${collectionId}`);

// 팔로워들에게 이벤트 알림
export const notifyToFollowers = (eventId) => axios.post(`/v1/private/events/${eventId}/notify-to-followers`);
